import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import FallingDots from './FallingDots'

function LoadingProgressBarContent({ styleObject }) {
  const MAX_PERCENTAGE = 80
  const MIN_PERCENTAGE = 45
  const [percentage, setPercentage] = React.useState(MAX_PERCENTAGE)

  // Alternate between MIN_PERCENTAGE and MAX_PERCENTAGE every 2 seconds
  // to sort of emulate google-style circular loader.
  useEffect(() => {
    const timeout = setTimeout(() => {
      setPercentage(percentage === MAX_PERCENTAGE ? MIN_PERCENTAGE : MAX_PERCENTAGE)
    }, 1000)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [percentage])

  return (
    <CircularProgressbar
      className="loading-progress-bar--rotating"
      value={percentage}
      styles={styleObject}
      strokeWidth={10}
    />
  )
}

LoadingProgressBarContent.propTypes = {
  styleObject: PropTypes.object,
}

// This is a workaround for the fact that CircularProgressBar doesn't support
// the "indeterminate" state. We use a timeout to alternate between two
// percentages to sort of emulate a loading state.
export default function LoadingProgressBar({
  visible,
  variant = 'circular', // 'circular' or 'fallingDots'
  text = '',
  styleObject = {
    trail: {
      stroke: '#8FB2CB',
    },
    path: {
      stroke: '#286D9B',
      // Can play with the timing on the percentage animation here
      transition: 'stroke-dashoffset 2s ease 0s',
      strokeLinecap: 'butt',
    },
  },
  className = '',
}) {
  return (
    <div className={`loading-progress-bar loading-progress-bar--${variant} ${className}`}>
      {visible &&
        (variant === 'fallingDots' ? (
          <FallingDots classNames="autofill_falling-dots" />
        ) : (
          <LoadingProgressBarContent styleObject={styleObject} />
        ))}
      {visible && text && <div className="loading-progress-bar__text">{text}</div>}
    </div>
  )
}

LoadingProgressBar.propTypes = {
  visible: PropTypes.bool,
  styleObject: PropTypes.object,
  className: PropTypes.string,
  text: PropTypes.string,
  variant: PropTypes.oneOf(['circular', 'fallingDots']),
}

LoadingProgressBar.variant = Object.freeze({
  circular: 'circular',
  fallingDots: 'fallingDots',
})
